import { Header } from '../Header';
import { LabelNotFoundState } from '../LabelNotFoundState';
import styles from '../LeaderboardPage/styles.module.css';
import { useTranslation } from 'react-i18next';

export function NoLabelPage() {
    const { t } = useTranslation();

    return (
        <div className={styles.leaderboardPage}>
            <Header title={t("noLabelState.headerTitle")} />
            <LabelNotFoundState />
        </div>
    )
}